import { Component } from '@angular/core';

@Component({
  selector: 'app-prroduct-order-bip',
  standalone: true,
  imports: [],
  templateUrl: './product-order-bip.component.html',
  styleUrl: './product-order-bip.component.css'
})
export class ProductOrderBipComponent {

}
